import { contains, curry, map } from "ramda";
import { createSelector } from "reselect";
import { State } from "../../../state";

export const getSelectedAccountsForPDF = (state: State) => {
  const selectedIds = map(
    selectedCell => selectedCell.account.id,
    state.selectedCells
  );
  const highlightedIds = map(
    highlightedCell => highlightedCell.accountId,
    state.highlightedCells
  );
  return selectedIds.concat(highlightedIds);
};

const isAccountSelectedHelper = curry(
  (selectedAccounts: string[], accountId: string): boolean =>
    contains(accountId, selectedAccounts)
);

export const getIsAccountSelected = createSelector(
  getSelectedAccountsForPDF,
  selectedAccounts => isAccountSelectedHelper(selectedAccounts)
);



// WEBPACK FOOTER //
// ./src/spread/model/selectedAccounts/selector.ts